const parserScripts = (string) => {
  const list = string
    .split('<\/script>')
    .filter((t) => !!t)
    .map((text) => {
      text = text.split('<script')?.[1] || '';
      text = text.split('>');
      const attributes = text[0];
      text.shift();
      text = text.join('');

      const attributesJson = {
        async: true,
        defer: true,
      };
      attributes.split(' ').map((attribute) => {
        if (attribute) {
          let [key, value] = attribute.split('=');
          value = value.replaceAll('"', '');
          value = value.replaceAll("\'", '');
          attributesJson[key] = value;
        }
      });

      return {
        ...attributesJson,
        innerHTML: text,
      };
    });

  return list;
};

export default parserScripts;
